import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

import { BaseDataService, HttpService } from "./base.service";

import { Observable } from "rxjs";
import { Container, OwnerChargeInfo } from "../../resources";

export interface ContainerServiceFilters {
  pageSize?: number;
  page?: number;
  limit?: number;
  search?: string;
}

@Injectable()
export class ContainerService extends BaseDataService<Container> {
  constructor(http: HttpService) {
    super(http, "container");
  }

  createInstance(options: any): Container {
    return new Container(options);
  }

  approve(id: number, approved: boolean): Observable<Container> {
    return this.runCommand("approve", { id, approved }).pipe(map((x) => x));
  }

  close(id: number, open: boolean): Observable<Container> {
    return this.runCommand("close", { id, open }).pipe(map((x) => x));
  }

  move(id: number, trackingNumber: string): Observable<Container> {
    return this.runCommand("move", { id, trackingNumber }).pipe(map((x) => x));
  }

  filterBy(filters: ContainerServiceFilters) {
    return this.all(filters);
  }

  exportList(searchParams: ContainerServiceFilters) {
    return this.http.exportList(`${this.resourceUrl}/exportList`, { searchParams });
  }

  updateManifests(containerNumber: string, trackingNumber: string) {
    const payload = { trackingNumber, containerNumber };
    return this.http.request(`${this.resourceUrl}/${containerNumber}`, { payload, method: "PUT" });
  }

  getOpenContainers(searchParams: ContainerServiceFilters) {
    console.log(searchParams);
    return this.http
      .request(`${this.resourceUrl}/open`, { searchParams })
      .pipe(map((response) => <any>this.processArrayOfEntities(response, (options) => options)));
  }

  getNexNumber() {
    return this.http.request(`${this.resourceUrl}/nextnumber`);
  }

  chargeInfo(cai: string): Observable<OwnerChargeInfo> {
    return this.http.request(`${this.resourceUrl}/chargeInfo`, { searchParams: { cai } });
  }

  printLayout() {
    return this.http.downloadText(`${this.resourceUrl}/printLayout`);
  }

  filterByManifest(trackingNumber: string) {
    return this.filterBy({
      search: `tracking-number-"${trackingNumber}" sort-by-"Container Detail" -Asc`,
    });
  }
}
